import Menu from './Compartido/Menu.jsx';
import TextosSobreNosotros from './SobreNosotros/TextosSobreNosotros.jsx';
import Caracteristicas from './Compartido/Caracteristicas.jsx';
import Footer from './Compartido/Footer.jsx';

const SobreNosotros = (props) => {

    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <TextosSobreNosotros
                sobrenosotros={props.textosobrenosotros}
                personas={props.personas}
                ruta={props.ruta}
            />
            <Caracteristicas
                caracteristicas={props.caracteristicas}
                config={props.config}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default SobreNosotros;
